module.exports = __webpack_public_path__ + "img/operacoes-cover.25171061.jpg";